import { AxiosResponse } from 'axios';
import { CaseResponseData } from 'modules/cm/api/cases/types';
import { Dispatch } from 'redux';
import { Action, GetState } from '../types';
import { ACTION_TYPES } from './types';
import diffChecker from '../caseDiffChecker';
import { historyPushDispatcher } from '../caseHistory/actions';
import { caseFromApi } from '../mapper';

const fieldsExcludedFromRefresh = [
  'updatedAt',
  'createdAt',
  // Readonly fields
  'applicants.*.currentIncomeEmployedTotal',
  'applicants.*.currentIncomeSelfEmployedTotal',
  'applicants.*.currentIncomeOtherTotal',
  'applicants.*.currentIncomeTotal',
  'applicants.*.minimumRetiredIncome',
  'applicants.*.commitmentToBeCleared',
  'applicants.*.commitmentRemaining',
  'applicants.*.age',
  'loanDetails.debtToIncome',
];

export const refresh = (fieldsToRefresh: string[]): Action => ({
  type: ACTION_TYPES.REFRESH,
  payload: [fieldsToRefresh, null],
});

export const resetRefresh = (): Action => ({
  type: ACTION_TYPES.RESET,
  payload: [null, null],
});

export const refreshProcess = (
  dispatch: Dispatch<Action>,
  getState: GetState,
  res: AxiosResponse<CaseResponseData>,
  updatedField: string,
) => {
  const historyPushDispatch = historyPushDispatcher(dispatch, getState);
  const currentCase = getState().currentCase;
  const caseDetails = currentCase.data ? caseFromApi(res.data.case) : null;
  const caseFromHistory =
    currentCase.history.length > 0 ? currentCase.history[currentCase.history.length - 1].case : null;

  if (caseDetails && caseFromHistory) {
    const diffResult = diffChecker.getDiffResults(caseFromHistory, caseDetails);
    const fieldsToRefresh = diffResult
      ? diffResult(updatedField, fieldsExcludedFromRefresh).map((result) => result.fieldPath)
      : [];
    if (fieldsToRefresh.length > 0) {
      dispatch(refresh(fieldsToRefresh));
    }
  }
  historyPushDispatch(res);
};
